export const getGroupByValues = (arr: string[]) =>
  arr.map(v => (v === null ? 'null' : v)).join('-')
